import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import store from './store'
import VueCompositionAPI from '@vue/composition-api'
import * as api from './api/index.js'
import request from './utils/request'
import http from './utils/http'

// 导入图标字体
import './static/iconfont.css'
// 导入TuniaoUI图标字体
import './tuniao-ui/iconfont.css'

// 引入TuniaoUI
import TuniaoUI from './tuniao-ui'
Vue.use(TuniaoUI)

// 使用Composition API插件
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

// 全局属性 - Vue2方式
Vue.prototype.$api = api
Vue.prototype.$request = request

// 注册 http 实例到 Vue 原型
Vue.prototype.$http = http

App.mpType = 'app'

const app = new Vue({
  store,
  ...App
})
app.$mount()

// 导出 Vue 实例供其他地方使用
export default app